/* /client/src/pages/SalesDetFuncs.js   */
/* Functions for sales detail           */

import React, { Component } from "react";
//import "./style.css"
import Axios           from "axios";
import {serverUrl}     from "../helpers/var";
import swal            from "sweetalert";   // Debería ser: npm i @sweetalert/with-react
import SalesDetailPage from "../pages/SalesDetailPage";
import moment          from "moment";
let todaySt;

class SalesDetFuncs extends Component {
   constructor(props) {
      super(props);
      const today = new Date();
      todaySt = today.getFullYear() + "-" + (today.getMonth()+1).toString().padStart(2,0) + "-" + today.getDate().toString().padStart(2,0);
      this.state = {
         master : {
            form : {
               document_id     : {value     : ""         , className : "form-control", 
                                  autofocus : "autofocus", dataValid : false, 
                                  disabled  : false},
               date            : {value     : todaySt    , className : "form-control", 
                                  autofocus : ""         , dataValid : false},
               usr_assoc_id    : {value     : ""         , className : "form-control", 
                                  autofocus : ""         , dataValid : false},
               internal_ref    : {value     : ""         , className : "form-control", 
                                  autofocus : ""         , dataValid : true},
               external_ref    : {value     : ""         , className : "form-control", 
                                  autofocus : ""         , dataValid : true},
               currency        : {value     : ""         , className : "form-control", 
                                  autofocus : ""         , dataValid : true},
               exchange_rate   : {value     : 0          , className : "form-control", 
                                  autofocus : ""         , dataValid : true},
               notes           : {value     : ""         , className : "form-control", 
                                  autofocus : ""         , dataValid : true}
            },
            id            : 0,
            document_type : "",
            associate_id  : 0,
            assoc_name    : "",
            action        : "",   // Add / Edit
            totalNoLines  : 0
         },
         detail : {
            form : {
               usr_prod_id  : {value     : ""         , className : "form-control", 
                               autofocus : "autofocus", dataValid : false},
               quantity     : {value     : 0          , className : "form-control", 
                               autofocus : ""         , dataValid : false},
               unit_measure : {value     : ""         , className : "form-control", 
                               autofocus :""          , dataValid : false},
               unit_cost    : {value     : 0          , className : "form-control", 
                               autofocus : ""         , dataValid : false},
               unit_price   : {value     : 0          , className : "form-control", 
                               autofocus : ""         , dataValid : false},
               line_cost    : {value     : 0          , className : "form-control", 
                               autofocus : ""         , dataValid : false},
               line_price   : {value     : 0          , className : "form-control", 
                               autofocus : ""         , dataValid : false},
               notes        : {value     : ""         , className : "form-control", 
                               autofocus : ""         , dataValid : false}
            },
            id            : 0,
            line_no       : 0,
            product_id    : 0,
            prod_desc     : "",
            ExchangeOpMId : 0,
            action        : "",
            orig_qty_edit : 0
         },
         msgs               : ["", " ", " "],
         DetButtonsBar      : {
            btnCfgAddDis : true
         },
         ExchCaptModal_show : false,
         ExchCapForm_status : "inicio",
         showAddLineBtn     : false,
         arrLines           : [],
         showDetModal       : false
      };

      this.handleChange     = this.handleChange.bind(this);
      this.handleSubmit     = this.handleSubmit.bind(this);
      this.handleDetChange  = this.handleDetChange.bind(this);
      this.handleDetSubmit  = this.handleDetSubmit.bind(this);
      this.checkMasterVal   = this.checkMasterVal.bind(this);
   }
   /* ---------------------------------------------------------- */
   componentDidMount () {
      const urlId = this.props.match.params;
      if (Object.keys(urlId).length === 0) {
         let newMaster = this.state.master;
         newMaster.action = "Add";
         this.setState( {master:newMaster} );
      } else {
         this.loadMasterRecord(urlId.id);
      }
   }
   /* ========================================================== */
      handleChange(event) {                                   // Master (Add, Edit)
      let newMaster = this.state.master;
      newMaster.form[event.target.id].value = event.target.value;
      let newDetButtonsBar = this.state.DetButtonsBar;
      if (this.state.master.action === "Edit") {
         newDetButtonsBar.btnCfgAddDis = false;
      };
      if ( (event.target.id === "document_id" ) ||
           (event.target.id === "date"        ) ||
           (event.target.id === "usr_assoc_id") ) {
         newMaster.form[event.target.id].dataValid = false;
         if (this.state.master.action === "Add") {
         newDetButtonsBar.btnCfgAddDis = true;
         };
      };
      this.setState({ master:newMaster, DetButtonsBar:newDetButtonsBar, msgs:["", "", ""] });
   };
   /* ---------------------------------------------------------- */
   checkMasterVal(event) {                                 // Master (Add, Edit)
      let fieldId = event.target.id;
      let fieldValue = event.target.value.trim();
      if ( ( (event.target.id === "document_id" ) ||
             (event.target.id === "date"        ) ||
             (event.target.id === "usr_assoc_id") ) &&
           (event.target.value.trim() === "") ) {
         let newMaster = this.state.master;
         newMaster.form[fieldId].dataValid = false;
         newMaster.form[fieldId].className = "form-control field-error";
         this.setState({ master:newMaster });
      } else {
         let newMaster = this.state.master;
         let newForm = this.state.master.form;
         newForm[fieldId].value = fieldValue;
         newMaster.form = newForm;
         this.setState({ master:newMaster }, function() {
            if (fieldId === "document_id" ) { this.checkValueDocId  (fieldId, fieldValue) } else
            if (fieldId === "date"        ) { this.checkValueDate   (fieldId, fieldValue) } else
            if (fieldId === "usr_assoc_id") { this.checkValueAsocId (fieldId, fieldValue) };
         });
      }
   };
   /* ---------------------------------------------------------- */
   checkAllMasterFieldsOk = (fieldId, fieldValueOk) => {   // Master (Add, Edit)
      let btnCfgSave = true;
      for (var property in this.state.master.form) {
         if (property === fieldId) {
            btnCfgSave = btnCfgSave && fieldValueOk;
         } else {
            btnCfgSave = btnCfgSave && this.state.master.form[property].dataValid;
         }
      };
      return btnCfgSave;
   };
   /* ---------------------------------------------------------- */
   checkValueDocId = (fieldId, fieldValue) => {            // Master (Add, Edit)
      Axios
         .get(serverUrl + "/api/exchange/S/usr/" + fieldValue)   // Porqué event y no state?
         .then  (
            res => {
               if (res.status !== 200) {
                  swal({
                     title: "Document Id",
                     text: "Error searching on database.",
                     icon: "warning",
                     dangerMode: true
                  });
                  console.log("Error:", res.status)
               } else {
                  let fieldValueOk = false;
                  if (res.data !== null) {
                     swal({
                        title: "Document Id",
                        text: "Already registered.",
                        icon: "warning",
                        dangerMode: true
                     });
                  } else {
                     fieldValueOk = true;
                  };
                  //---
                  let newMaster = this.state.master;
                  newMaster.form[fieldId].dataValid = fieldValueOk;
                  fieldValueOk ? newMaster.form[fieldId].className = "form-control"
                               : newMaster.form[fieldId].className = "form-control field-error";
                  let newDetButtonsBar = this.state.DetButtonsBar;
                  newDetButtonsBar.btnCfgAddDis = !this.checkAllMasterFieldsOk (fieldId, fieldValueOk);
                  this.setState({ master:newMaster, DetButtonsBar:newDetButtonsBar });
                  //---
               };
            }
         )
         .catch (err => {
            swal({
               title: "Document Id",
               text: "Error searching on database.",
               icon: "warning",
               dangerMode: true
            });
            console.log("Error:", err);
         });
   };
   /* ---------------------------------------------------------- */
   checkValueDate = (fieldId, fieldValue) => {             // Master (Add, Edit)
      let fieldValueOk = moment(fieldValue.trim(), "YYYY-M-D", true).isValid();
      //---
      let newMaster = this.state.master;
      newMaster.form[fieldId].dataValid = fieldValueOk;
      newMaster.form[fieldId].value = fieldValue.trim();
      fieldValueOk ? newMaster.form[fieldId].className = "form-control"
                   : newMaster.form[fieldId].className = "form-control field-error";
      let newDetButtonsBar = this.state.DetButtonsBar;
      newDetButtonsBar.btnCfgAddDis = !this.checkAllMasterFieldsOk (fieldId, fieldValueOk);
      this.setState({ master:newMaster, DetButtonsBar:newDetButtonsBar });
      //---
      if (!fieldValueOk)
         swal({
            title: "Date",
            text: "Wrong date. Expected format: YYYY-MM-DD",
            icon: "warning",
            dangerMode: true
         });
   };
   /* ---------------------------------------------------------- */
   checkValueAsocId = (fieldId, fieldValue) => {           // Master (Add, Edit)
      this.loadNameAsoc(fieldId, fieldValue);
   };
   /* ---------------------------------------------------------- */
   loadNameAsoc(fieldId, fieldValue) {                     // Master (Add, Edit)
      let RecordId = fieldValue.trim();
      Axios
         .get(serverUrl + "/api/associates/C/usr/" + RecordId)
         .then  (
            res => {
               if (res.status !== 200) {
                  swal({
                     title: "Associate Id",
                     text: "Error searching on database.",
                     icon: "warning",
                     dangerMode: true
                  });
                  console.log("Error:", res.status)
               } else {
                  let fieldValueOk = false;
                  let name = "";
                  let id = 0;
                  if (res.data === null) {
                     swal({
                        title: "Associate Id",
                        text: "Not found.",
                        icon: "warning",
                        dangerMode: true
                     });
                  } else {
                     fieldValueOk = true;
                     name = res.data.name;
                     id = res.data.id;
                  };
                  //---
                  let newMaster = this.state.master;
                  newMaster.form[fieldId].dataValid = fieldValueOk;
                  newMaster.form[fieldId].value = RecordId;
                  fieldValueOk ? newMaster.form[fieldId].className = "form-control"
                               : newMaster.form[fieldId].className = "form-control field-error";
                  newMaster.assoc_name = name;
                  newMaster.associate_id = id;
                  let newDetButtonsBar = this.state.DetButtonsBar;
                  newDetButtonsBar.btnCfgAddDis = !this.checkAllMasterFieldsOk ("usr_assoc_id", fieldValueOk);
                  this.setState({ master:newMaster, DetButtonsBar:newDetButtonsBar });
                  //---
               };
            }
         )
         .catch (err => {
            swal({
               title: "Associate Id",
               text: "Error searching on database.",
               icon: "warning",
               dangerMode: true
            });
            console.log("Error:", err);
         });
   }
   /* ---------------------------------------------------------- */
   loadMasterRecord(masterId) {                            // Master (Edit)
      Axios
         .get(serverUrl + "/api/exchange/S/" + masterId)
         .then  (
            res => {
               this.showMasterRecord(res.data);
            }
         )
         .catch (err => {
            let newMsgs = this.state.msgs;
            newMsgs[0] = "Error";
            this.setState({msgs:newMsgs});
            console.log("Error:", err);
         });
   }
   /* ---------------------------------------------------------- */
   showMasterRecord(resData) {                             // Master (Edit)
      let newForm = this.state.master.form;
      for (var field in newForm){
         newForm[field].value = resData[field];
         newForm[field].autofocus = "";
         newForm[field].dataValid = true;
      };
      newForm.document_id.disabled = true;
      let newMaster = this.state.master;
      newMaster.form = newForm;
      newMaster.id = resData.id;
      newMaster.document_type = resData.document_type;
      newMaster.associate_id = resData.associate_id;
      newMaster.assoc_name = resData.Associate.name;
      newMaster.action = "Edit";
      // ----------------
      let newArrLines = [];
      resData.Exchange_Op_Ds.forEach( function (rec) {
         newArrLines.push({
            id           : rec.id,            // El 1er campo no se desplegará, se asume id
            line_no      : rec.line_no,
            usr_prod_id  : rec.usr_prod_id,   // A partir de aquí sí se despliegan
            product_desc : rec.Product.description,
            quantity     : rec.quantity,
            unit_measure : rec.unit_measure,
            unit_cost    : rec.unit_cost,
            line_cost    : rec.line_cost,
            product_id   : rec.product_id,    // A partir de este ya no se despliegan (ExchDetForm)
            unit_price   : rec.unit_price,
            line_price   : rec.line_price,
            notes        : rec.notes
         });
      });
      newMaster.totalNoLines = newArrLines.length;
      // ----------------
      this.setState({
         master         : newMaster,
         arrLines       : newArrLines,
         showAddLineBtn : true 
      });
   }
   /* ---------------------------------------------------------- */
/* console.log("showMasterRecord / resData=", resData);
associate_id: 4
createdAt: "2019-10-10T01:53:52.000Z"
currency: "mn"
date: "2019-10-09"
document_id: "1"
document_type: "P"
exchange_rate: 1
external_ref: "ext-1"
id: 1
internal_ref: "int-1"
notes: "obs 1"
updatedAt: "2019-10-10T01:53:52.000Z"
usr_assoc_id: "Prv_1"
   - - -
Associate:
   address: "Cda Suiza"
   associate_type: "P"
   createdAt: "2019-08-06T05:38:19.000Z"
   email: "info@aspel.com"
   id: 4
   name: "Aspel de Mex"
   notes: "Proveedor Aspel"
   phone: "5325-2323"
   tax_id: "AME123456-ABC"
   updatedAt: "2019-08-06T05:38:19.000Z"
   user_id: "Prv_1"
   - - -
Exchange_Op_Ds:
   0: {
      ExchangeOpMId: 1
      Product: {
         cost: 1000
         createdAt: "2019-08-06T05:38:14.000Z"
         description: "1,000 Timbres Aspel"
         existence: 2
         family: "Asp"
         id: 1
         notes: "Servicio de Timbrado Aspel"
         price: 1400
         product_type: "P"
         unit_measure: "Srvc"
         updatedAt: "2019-10-12T17:28:47.000Z"
         user_id: "A9TIM-1000"
      }
      createdAt: "2019-11-08T05:50:28.000Z"
      id: 1
      line_cost: 1800
      line_no: 1
      line_price: 2400
      notes: ""
      product_id: 1
      quantity: 2
      unit_cost: 900
      unit_measure: "Srvc"
      unit_price: 1200
      updatedAt: "2019-11-08T05:50:28.000Z"
      usr_prod_id: "A9TIM-1000"
   }
*/
   /* ---------------------------------------------------------- */
   handleSubmit(event) {                                   // Master (Add, Edit)
      let allMasterFieldsOk = true;
      let wrongField = "";
      for (var property in this.state.master.form) {
         allMasterFieldsOk = allMasterFieldsOk && this.state.master.form[property].dataValid;
         if (!this.state.master.form[property].dataValid) wrongField = property;
      }
      if (!allMasterFieldsOk) {
         swal({
            title: wrongField,
            text: "Missing or wrong information detected on field.",
            icon: "warning",
            dangerMode: true
         });
      } else {
         if (this.state.master.action === "Add") {
            this.handleAdd();
         } else {
            if (this.state.master.action === "Edit") {
               this.handleSave();
            }
         };
      }
   }
   /* ---------------------------------------------------------- */
   handleAdd = () => {                                     // Master (Add)
      Axios
         .post(serverUrl + "/api/exchange/S",
         {
            document_id   : this.state.master.form.document_id.value,
            date          : this.state.master.form.date.value,
            usr_assoc_id  : this.state.master.form.usr_assoc_id.value,
            associate_id  : this.state.master.associate_id,
            internal_ref  : this.state.master.form.internal_ref.value,
            external_ref  : this.state.master.form.external_ref.value,
            currency      : this.state.master.form.currency.value,
            exchange_rate : this.state.master.form.exchange_rate.value,
            notes         : this.state.master.form.notes.value
         })
         .then  (
            res => {
               let newMaster = this.state.master;
               newMaster.id = res.data.id;
               let newMsgs = this.state.msgs;
               newMsgs[0] = "Head added: " + res.statusText;
               let newDetail = this.state.detail;
               let showDetModal = this.state.showDetModal;
               if (this.state.master.action === "Add") {
                  newDetail.action = "Add";
                  showDetModal = true;
               };
               this.setState({
                  master         : newMaster, 
                  detail         : newDetail, 
                  msgs           : newMsgs, 
                  showAddLineBtn : true,
                  showDetModal   : showDetModal
               });
            }
         )
         .catch (err => {
            let newMsgs = this.state.msgs;
            newMsgs[0] = "Error";
            this.setState({msgs:newMsgs});
            console.log("Error:", err);
         });
   };
   /* ---------------------------------------------------------- */
   handleSave = () => {                                    // Master (Edit)
      Axios
         .put(serverUrl + "/api/exchange/S/" + this.state.master.id,
         {
            document_id   : this.state.master.form.document_id.value,
            date          : this.state.master.form.date.value,
            usr_assoc_id  : this.state.master.form.usr_assoc_id.value,
            associate_id  : this.state.master.associate_id,
            internal_ref  : this.state.master.form.internal_ref.value,
            external_ref  : this.state.master.form.external_ref.value,
            currency      : this.state.master.form.currency.value,
            exchange_rate : this.state.master.form.exchange_rate.value,
            notes         : this.state.master.form.notes.value
         })
         .then  (
            res => {
               let newstate = {msgs : ["Head updated: " + res.statusText]}; 
               this.setState(newstate);
               if (res.status === 200) swal("Record has been updated");
            }
         )
         .catch (err => {
            let newMsgs = this.state.msgs;
            newMsgs[0] = "Error";
            this.setState({msgs:newMsgs});
            console.log("Error:", err);
         });
   };
   /* ---------------------------------------------------------- */
   handleDelete = () => {
      swal({
         title: "Delete",
         text: "Sure to delete record?",
         icon: "warning",
         buttons: true,
         dangerMode: true
      })
      .then(willDelete => { if (willDelete) {
         this.handleMasterDelete();
      } });
   };
   /* ---------------------------------------------------------- */
   clearStateVars() {                                      // Master (Delete)
      this.setState({
         master : {
            form : {
               document_id     : {value     : ""         , className : "form-control", 
                                  autofocus : "autofocus", dataValid : false, 
                                  disabled  : false},
               date            : {value     : todaySt    , className : "form-control", 
                                  autofocus : ""         , dataValid : false},
               usr_assoc_id    : {value     : ""         , className : "form-control", 
                                  autofocus : ""         , dataValid : false},
               internal_ref    : {value     : ""         , className : "form-control", 
                                  autofocus : ""         , dataValid : true},
               external_ref    : {value     : ""         , className : "form-control", 
                                  autofocus : ""         , dataValid : true},
               currency        : {value     : ""         , className : "form-control", 
                                  autofocus : ""         , dataValid : true},
               exchange_rate   : {value     : 0          , className : "form-control", 
                                  autofocus : ""         , dataValid : true},
               notes           : {value     : ""         , className : "form-control", 
                                  autofocus : ""         , dataValid : true}
            },
            id            : 0,
            document_type : "",
            associate_id  : 0,
            assoc_name    : "",
            action        : "",   // Add / Edit
            totalNoLines  : 0
         },
         detail : {
            form : {
               usr_prod_id  : {value     : ""         , className : "form-control", 
                               autofocus : "autofocus", dataValid : false},
               quantity     : {value     : 0          , className : "form-control", 
                               autofocus : ""         , dataValid : false},
               unit_measure : {value     : ""         , className : "form-control", 
                               autofocus :""          , dataValid : false},
               unit_cost    : {value     : 0          , className : "form-control", 
                               autofocus : ""         , dataValid : false},
               unit_price   : {value     : 0          , className : "form-control", 
                               autofocus : ""         , dataValid : false},
               line_cost    : {value     : 0          , className : "form-control", 
                               autofocus : ""         , dataValid : false},
               line_price   : {value     : 0          , className : "form-control", 
                               autofocus : ""         , dataValid : false},
               notes        : {value     : ""         , className : "form-control", 
                               autofocus : ""         , dataValid : false}
            },
            id            : 0,
            line_no       : 0,
            product_id    : 0,
            prod_desc     : "",
            ExchangeOpMId : 0,
            action        : "",
            orig_qty_edit : 0
         },
         msgs               : ["", " ", " "],
         DetButtonsBar      : {
            btnCfgAddDis : true
         },
         ExchCaptModal_show : false,
         ExchCapForm_status : "inicio",
         showAddLineBtn     : false,
         arrLines           : [],
         showDetModal       : false
      });
   }
   /* ---------------------------------------------------------- */
   handleMasterDelete = () => {                            // Master (Delete)
      Axios
         .delete(serverUrl + "/api/exchange/S/" + this.state.master.id)
         .then  (
            res => {
              this.setState({msgs:[res.statusText]});
               if (res.status === 200) {
                  swal("Record has been deleted")
                     .then(resp => {
                        if (resp) {
                           this.clearStateVars();
                           window.location = "/salesList";
                        }
                     });
               }
            }
         )
         .catch (err => {
            let newMsgs = this.state.msgs;
            newMsgs[0] = "Error";
            this.setState({msgs:newMsgs});
            console.log("Error:", err);
         });
   };
   /* ---------------------------------------------------------- */

   /* ---------------------------------------------------------- */
   /*              Inicia la sección de Detalle                  */
   /* ---------------------------------------------------------- */
   handleShowDetModal  = () => {   // debería ser: handleShowDetAddModal
      let newDetail = this.state.detail;
      newDetail.action = "Add";
      let newState = this.state;
      newState.detail = newDetail;
      newState.showDetModal = true;
      this.setState({newState});
   }

   handleCloseDetModal = () => {
      let newDetail = this.state.detail;
      newDetail.action = "";
      let newState = this.state;
      newState.detail = newDetail;
      newState.showDetModal = false;
      this.setState({newState});
   }
   /* ---------------------------------------------------------- */
   handleDetChange(event) {                                // Detail (Add, Edit)
      let newDetail = this.state.detail;
      newDetail.form[event.target.id].value = event.target.value;
      if (event.target.id === "usr_prod_id") {
         newDetail.form[event.target.id].dataValid = false;
      };
      this.setState({ detail:newDetail, msgs:["", "", ""] });
   }
   /* ---------------------------------------------------------- */
   checkDetailVal = (event) => {                           // Detail (Add, )
      // Requiere arrow function para hacer un bind del "this.state"
      let fieldId = event.target.id;
      let fieldValue = event.target.value.trim ();
      if ((fieldId === "usr_prod_id") &&   // Es el único campo que se verifica
          (fieldValue === "")) {
         swal({
            title: "Product Id",
            text: "Must provide a value for this field.",
            icon: "warning",
            dangerMode: true
         });
      } else {
         this.checkValueProdId(fieldId, fieldValue);
      }
   };
   /* ---------------------------------------------------------- */
   checkValueProdId = (fieldId, fieldValue) => {
      this.loadNameProd(fieldId, fieldValue);
   };
   /* ---------------------------------------------------------- */
   loadNameProd(fieldId, ProdUsrId) {
      let newDetail = {};
      Axios
         .get(serverUrl + "/api/products/usr/" + ProdUsrId)
         .then  (
            res => {
               if (res.status !== 200) {
                  swal({
                     title: "Product Id",
                     text: "Error searching on database.",
                     icon: "warning",
                     dangerMode: true
                  });
                  console.log("Error:", res.status)
               } else {
                  newDetail = this.state.detail;
                  if (res.data === null) {
                     newDetail.form[fieldId].className = "form-control field-error";
                     newDetail.prod_desc = "";
                     newDetail.form.unit_measure.value = "";
                     swal({
                        title: "Product Id",
                        text: "Not found.",
                        icon: "warning",
                        dangerMode: true
                     });
                  } else {
                     newDetail.form[fieldId].className = "form-control";
                     newDetail.form[fieldId].dataValid = true;
                     newDetail.product_id = res.data.id;
                     newDetail.prod_desc = res.data.description;
                     newDetail.form.unit_measure.value = res.data.unit_measure;
                     newDetail.form.unit_cost.value    = res.data.cost;
                     newDetail.form.unit_price.value   = res.data.price;
                  };
               };
               this.setState( {detail:newDetail} );
            }
         )
         .catch (err => {
            let newMsgs = this.state.msgs;
            newMsgs[0] = "Error";
            this.setState({msgs:newMsgs});
            console.log("Error:", err);
         });
   }
   /* ---------------------------------------------------------- */
   handleDetSubmit() {                                     // Detail (Add, Edit)
      if (this.state.detail.form.usr_prod_id.value === "") {
         swal({
            title: "Product Id",
            text: "Please fill in the field.",
            icon: "warning",
            dangerMode: true
         });
      } else {
         if (this.state.detail.action === "Add") {
            this.handleDetAdd();
         } else if (this.state.detail.action === "Edit") {
            this.handleDetSave();
         };
      };
   }
   /* ---------------------------------------------------------- */
   handleDetAdd  = () => {                                 // Detail (Add)
      let line_no = this.state.master.totalNoLines + 1;
          Axios
          .post(serverUrl + "/api/exchangeD",
            {
               line_no       : line_no,
               usr_prod_id   : this.state.detail.form.usr_prod_id.value,
               quantity      : this.state.detail.form.quantity.value,
               unit_measure  : this.state.detail.form.unit_measure.value,
               unit_cost     : this.state.detail.form.unit_cost.value,
               unit_price    : this.state.detail.form.unit_price.value,
               line_cost     : this.state.detail.form.quantity.value *
                               this.state.detail.form.unit_cost.value,
               line_price    : this.state.detail.form.quantity.value *
                               this.state.detail.form.unit_price.value,
               notes         : this.state.detail.form.notes.value,
               ExchangeOpMId : this.state.master.id,
               product_id    : this.state.detail.product_id,
               document_type : "S"
             })
          .then  (
            res => {
               let newMaster = this.state.master;
               newMaster.totalNoLines = this.state.master.totalNoLines + 1;
               let newArrLines = this.state.arrLines;
               newArrLines.push({
                  id           : res.data.id,
                  line_no      : res.data.line_no,
                  usr_prod_id  : res.data.usr_prod_id,
                  product_desc : this.state.detail.prod_desc,
                  quantity     : res.data.quantity,
                  unit_measure : res.data.unit_measure,
                  unit_cost    : res.data.unit_cost,
                  line_cost    : res.data.line_cost,
                  product_id   : res.data.product_id,
                  unit_price   : res.data.unit_price,
                  line_price   : res.data.line_price,
                  notes        : res.data.notes
      
               });
               // ----------------
               let newDetail = {
                     form : {
                        usr_prod_id  : {value     : ""         , className : "form-control", 
                                        autofocus : "autofocus", dataValid : false},
                        quantity     : {value     : 0          , className : "form-control", 
                                        autofocus : ""         , dataValid : false},
                        unit_measure : {value     : ""         , className : "form-control", 
                                        autofocus :""          , dataValid : false},
                        unit_cost    : {value     : 0          , className : "form-control", 
                                        autofocus : ""         , dataValid : false},
                        unit_price   : {value     : 0          , className : "form-control", 
                                        autofocus : ""         , dataValid : false},
                        line_cost    : {value     : 0          , className : "form-control", 
                                        autofocus : ""         , dataValid : false},
                        line_price   : {value     : 0          , className : "form-control", 
                                        autofocus : ""         , dataValid : false},
                        notes        : {value     : ""         , className : "form-control", 
                                        autofocus : ""         , dataValid : false}
                     },
                     id            : 0,
                     line_no       : line_no + 1,
                     product_id    : 0,
                     prod_desc     : "",
                     ExchangeOpMId : res.data.ExchangeOpMId,
                     action        : "Add"
               };
               // ----------------
               let newMsgs = this.state.msgs;
               if (this.state.detail.action === "Add") {
                  newMsgs[1] = "Line added: " + res.statusText;
               } else if (this.state.detail.action === "Edit") {   // creo que no aplica x este proc es para Add. revisar!
                  newMsgs[1] = "Line saved: " + res.statusText;
               };
               this.setState( {master:newMaster, detail:newDetail, arrLines:newArrLines, msgs:newMsgs});
            }
          )
          .catch (err => {
            let newMsgs = this.state.msgs;
            newMsgs[0] = "Error";
            this.setState({msgs:newMsgs});
            console.log("Error:", err);
          });
   };
   /* ---------------------------------------------------------- * /
   res.data =
   id:1, line_no:1, usr_prod_id:"A9TIM-1000", quantity:2, unit_measure:"Srvc", 
   ExchangeOpMId: 1
   createdAt: "2019-11-08T05:50:28.595Z"
   id: 1
   line_cost: 1800
   line_no: 1
   line_price: 2400
   notes: ""
   product_id: 1
   quantity: "2"
   unit_cost: "900"
   unit_measure: "Srvc"
   unit_price: "1200"
   updatedAt: "2019-11-08T05:50:28.595Z"
   usr_prod_id: "A9TIM-1000"
   /* ---------------------------------------------------------- */
   handleDetSave  = () => {                                // Detail (Edit)
          Axios
          .put(serverUrl + "/api/exchangeD/" + this.state.detail.id,
            {
               //line_no       : this.state.detail.line_no,
               usr_prod_id   : this.state.detail.form.usr_prod_id.value,
               quantity      : this.state.detail.form.quantity.value,
               unit_measure  : this.state.detail.form.unit_measure.value,
               unit_cost     : this.state.detail.form.unit_cost.value,
               unit_price    : this.state.detail.form.unit_price.value,
               line_cost     : this.state.detail.form.quantity.value *
                               this.state.detail.form.unit_cost.value,
               line_price    : this.state.detail.form.quantity.value *
                               this.state.detail.form.unit_price.value,
               notes         : this.state.detail.form.notes.value,
               //ExchangeOpMId : this.state.detail.ExchangeOpMId,
               product_id    : this.state.detail.product_id,
               orig_qty_edit : this.state.detail.orig_qty_edit
            })
          .then  (
            res => {
               const prevId = this.state.detail.id;
               let newArr = this.state.arrLines.filter(
                  function(rec) { return rec.id !== prevId }
               );
               newArr = newArr.concat([{
                  id            : prevId,
                  line_no       : this.state.detail.line_no,
                  usr_prod_id   : this.state.detail.form.usr_prod_id.value,
                  product_desc  : this.state.detail.prod_desc,
                  quantity      : this.state.detail.form.quantity.value,
                  unit_measure  : this.state.detail.form.unit_measure.value,
                  unit_cost     : this.state.detail.form.unit_cost.value,
                  line_cost     : this.state.detail.form.quantity.value *
                                  this.state.detail.form.unit_cost.value,
                  product_id    : this.state.detail.product_id,
                  unit_price    : this.state.detail.form.unit_price.value,
                  line_price    : this.state.detail.form.quantity.value *
                                  this.state.detail.form.unit_price.value,
                  notes         : this.state.detail.form.notes.value
               }]);
               newArr = newArr.sort(
                  function (a, b){ return a.line_no - b.line_no }
               );
               let newState = this.state;
               newState.arrLines = newArr;
               newState.msgs[1] = "Line: " + res.statusText;
               newState.showDetModal = false;
               this.setState(newState);             // Debería limpiar this.state.detail ??
            }
          )
          .catch (err => {
            let newMsgs = this.state.msgs;
            newMsgs[1] = "Line: Error";
            this.setState({msgs:newMsgs});
            console.log("Error:", err);
          });
   };
   /* ---------------------------------------------------------- * /
      db.Exchange_Op_D.create({
         line_no:       req.body.line_no,
         usr_prod_id:   req.body.usr_prod_id,
         quantity:      req.body.quantity,
         unit_measure:  req.body.unit_measure,
         unit_cost:     req.body.unit_cost,
         unit_price:    req.body.unit_price,
         line_cost:     req.body.line_cost,
         line_price:    req.body.line_price,
         notes:         req.body.notes,
         ExchangeOpMId: req.body.ExchangeOpMId,
         product_id:    req.body.product_id
      }).then(function(dbRes) {
   /* ---------------------------------------------------------- */
   handleShowDetModalEdit  = (id) => {   // revisar el nombre; sugerí un handleShowDetModalAdd
      let idx ;
      this.state.arrLines.forEach( 
         (rec, index) => { if (rec.id===id) idx = index }
      );
      let newDetail = this.state.detail;
      newDetail.form.usr_prod_id.value  = this.state.arrLines[idx].usr_prod_id;
      newDetail.form.usr_prod_id.autofocus = "";
      newDetail.form.usr_prod_id.dataValid = true;
      newDetail.form.quantity.value     = this.state.arrLines[idx].quantity;
      newDetail.orig_qty_edit           = this.state.arrLines[idx].quantity;
      newDetail.form.unit_measure.value = this.state.arrLines[idx].unit_measure;
      newDetail.form.unit_cost.value    = this.state.arrLines[idx].unit_cost;
      newDetail.form.unit_price.value   = this.state.arrLines[idx].unit_price;
      newDetail.form.line_cost.value    = this.state.arrLines[idx].line_cost;
      newDetail.form.line_price.value   = this.state.arrLines[idx].line_price;
      newDetail.form.notes.value        = this.state.arrLines[idx].notes;
      newDetail.id            = this.state.arrLines[idx].id;
      newDetail.line_no       = this.state.arrLines[idx].line_no;
      newDetail.product_id    = this.state.arrLines[idx].product_id;
      newDetail.prod_desc     = this.state.arrLines[idx].product_desc;
      newDetail.ExchangeOpMId = this.state.master.id;
      newDetail.action        = "Edit";
      this.setState({
         detail         : newDetail,
         showDetModal   : true
      });
   };
   /* ---------------------------------------------------------- * /
   let newArrLines = [];
   resData.Exchange_Op_Ds.forEach( function (rec) {
      newArrLines.push({
         id           : rec.id,
         line_no      : rec.line_no,
         usr_prod_id  : rec.usr_prod_id,
         product_desc : rec.Product.description,
         quantity     : rec.quantity,
         unit_measure : rec.unit_measure,
         unit_cost    : rec.unit_cost,
         line_cost    : rec.line_cost,
         product_id   : rec.product_id
      });
   });
   /* ---------------------------------------------------------- */

   render() {
      return ( <SalesDetailPage
                  state                  = {this.state}
                  handleSubmit           = {this.handleSubmit}
                  handleDelete           = {this.handleDelete}
                  handleChange           = {this.handleChange}
                  checkMasterVal         = {this.checkMasterVal}
                  handleShowDetModal     = {this.handleShowDetModal}
                  handleDetChange        = {this.handleDetChange}
                  handleDetSubmit        = {this.handleDetSubmit}
                  handleCloseDetModal    = {this.handleCloseDetModal}
                  handleShowDetModalEdit = {this.handleShowDetModalEdit}
                  checkDetailVal         = {this.checkDetailVal}
               />
             );
   }
}

export default SalesDetFuncs;